import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {
	FirmwareAssignmentContext,
	IFirmwareAssignmentContext,
	TActiveItemToDisplay,
} from 'modules/FirmwareAndApp/Firmware/FirmwareAssignment/firmwareAssignmentState/firmwareAssignmentContext';
import React, { useContext } from 'react';
import style from './SectionsSwitcher.module.scss';

const SectionsSwitcher: React.FC = () => {
	const {
		changeActiveItemToDisplay,
		activeItemToDisplay,
		allCustomers,
		IDsSelectedCustomers,
		IDsSelectedRestaurants,
	} = useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const buttonClasses = (itemName: TActiveItemToDisplay) =>
		classNames(style.button, { [style.withoutHover]: activeItemToDisplay === itemName });

	const customersButtonActiveState = activeItemToDisplay === 'customers' || !allCustomers.length;
	const restaurantsButtonActiveState =
		activeItemToDisplay === 'restaurants' || !Object.keys(IDsSelectedCustomers).length;
	const firmwareButtonActiveState = activeItemToDisplay === 'firmware' || !Object.keys(IDsSelectedRestaurants).length;

	return (
		<div data-test="SectionsSwitcher" className={style.container}>
			<Button
				className={buttonClasses('customers')}
				theme={customersButtonActiveState ? 'primaryBlue' : 'secondary'}
				onClick={() => changeActiveItemToDisplay('customers')}
				disabled={!allCustomers.length}>
				<Text translationNameSpace="listing" translationKey="customersLabel" asFragment={true} />
			</Button>
			<Button
				className={buttonClasses('restaurants')}
				theme={restaurantsButtonActiveState ? 'primaryBlue' : 'secondary'}
				onClick={() => changeActiveItemToDisplay('restaurants')}
				disabled={!Object.keys(IDsSelectedCustomers).length}>
				<Text translationNameSpace="listing" translationKey="restaurantsLabel" asFragment={true} />
			</Button>
			<Button
				className={buttonClasses('firmware')}
				theme={firmwareButtonActiveState ? 'primaryBlue' : 'secondary'}
				onClick={() => changeActiveItemToDisplay('firmware')}
				disabled={!Object.keys(IDsSelectedRestaurants).length}>
				<Text translationNameSpace="listing" translationKey="firmwareLabel" asFragment={true} />
			</Button>
		</div>
	);
};

export default SectionsSwitcher;
